import { render } from "./InvestmentOwner.vue?vue&type=template&id=0311d9d8&scoped=true"
import script from "./InvestmentOwner.vue?vue&type=script&lang=js"
export * from "./InvestmentOwner.vue?vue&type=script&lang=js"

import "./InvestmentOwner.vue?vue&type=style&index=0&id=0311d9d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0311d9d8"]])

export default __exports__